import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import BoxChampEscalatedNotice from '../scanpack/BoxChampEscalatedNotice';
import {setBoxChampState, clearBoxChampConfirmationTimer} from '../../actions/scanpackScanningActions';
import {useBoxChampGuided} from './hooks/useBoxChampGuided';

const BoxChampEscalatedLayer = () => {
  const dispatch = useDispatch();
  const {modalOpen} = useBoxChampGuided();
  const message = useSelector(state => state.scanPackScanning.boxChamp?.setAsideMessage || '');
  const confirmation = useSelector(state => Boolean(state.scanPackScanning.boxChamp?.setAsideConfirmation));

  if (!modalOpen) return null;
  return (
    <BoxChampEscalatedNotice
      message={message}
      tone={confirmation ? 'info' : 'warning'}
      onDismiss={() => {
        clearBoxChampConfirmationTimer();
        dispatch(setBoxChampState({setAsideMessage: '', setAsideConfirmation: false}));
      }}
    />
  );
};

export default BoxChampEscalatedLayer;
